import './index.css'

import { Component } from 'react'
import PropTypes from 'prop-types'
import { nanoid } from 'nanoid'
import dayjs from 'dayjs'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'

class MonthYearPicker extends Component {
  constructor(props) {
    super(props)

    let value = dayjs().date(1).format('MM/DD/YYYY')
    if (props.value.length) {
      value = dayjs(props.value).format('MM/DD/YYYY')
    }

    let month = dayjs(value).month()
    let year = dayjs(value).year()

    this.months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ]

    this.state = {
      field: this.props.field,
      value: value,
      month: month,
      year: year,
      onFocus: false,
      id: nanoid(),
      showCurrently: this.props.showCurrently,
      isCurrently: this.props.isCurrently,
    }
  }

  onFocus = e => {
    if (this.props.isDisabled) return

    this.setState({ onFocus: true })
  }
  onBlur = e => {
    this.setState({ onFocus: false })
  }

  updateYear = number => {
    if (this.state.isCurrently) return

    let year = this.state.year + number
    let value = dayjs(this.state.value).year(year).format('MM/DD/YYYY')

    this.setState({ year, value })
    this.props.updateDate(this.state.field, value)
  }

  updateMonth = month => {
    if (this.state.isCurrently) return

    let value = dayjs(this.state.value).month(month).format('MM/DD/YYYY')

    this.setState({ month, value })
    this.props.updateDate(this.state.field, value)
  }

  updateCurrently = () => {
    let isCurrently = !this.state.isCurrently

    this.setState({ isCurrently })
    this.props.updateCurrently()
  }

  showDate = () => {
    if (this.props.isDisabled) {
      return ''
    }

    if (this.state.isCurrently) {
      return 'Present'
    }

    if (this.props.value === '') {
      return dayjs().date(1).format('MMM, YYYY')
    }

    return dayjs(this.props.value).date(1).format('MMM, YYYY')
  }

  render() {
    let switchButton = <div className="month-picker-bottom"></div>

    if (this.state.showCurrently) {
      switchButton = (
        <div className="month-picker-bottom">
          <label className="month-picker-bottom-label" onClick={this.updateCurrently}>
            <div className={`radio-content ${this.state.isCurrently ? 'active' : 'disable'}`}>
              <div
                className={`radio-button ${this.state.isCurrently ? 'active' : 'disable'}`}
              ></div>
            </div>
            Up to day
          </label>
        </div>
      )
    }

    return (
      <div className="text-input" tabIndex={0} onFocus={this.onFocus} onBlur={this.onBlur}>
        <div>
          <input
            readOnly={true}
            disabled={this.state.isDisabled}
            type="text"
            value={this.showDate()}
          />
          <div className={`text-input-border-bottom ${this.state.onFocus ? 'active' : ''}`} />

          <div className={`month-year-picker-content ${this.state.onFocus ? 'active' : 'disable'}`}>
            <div className="year-picker">
              <div
                className={`year-picker-arrow ${this.state.isCurrently ? 'disable' : 'active'}`}
                onClick={e => this.updateYear(-1)}
              >
                <FontAwesomeIcon icon={faChevronLeft} />
              </div>
              <div className={`year-picker-value ${this.state.isCurrently ? 'disable' : 'active'}`}>
                {this.state.year}
              </div>
              <div
                className={`year-picker-arrow ${this.state.isCurrently ? 'disable' : 'active'}`}
                onClick={e => this.updateYear(+1)}
              >
                <FontAwesomeIcon icon={faChevronRight} />
              </div>
            </div>
            <div className="month-picker">
              {this.months.map((month, index) => (
                <div
                  onClick={e => this.updateMonth(index)}
                  className={`month-picker-value ${this.state.isCurrently ? 'disable' : 'active'} ${
                    index === this.state.month ? 'month-selected' : ''
                  }`}
                  key={index}
                >
                  {month}
                </div>
              ))}
            </div>

            {switchButton}
          </div>
        </div>
      </div>
    )
  }
}

const today = dayjs().date(1).format('MM/DD/YYYY')

MonthYearPicker.propTypes = {
  showCurrently: PropTypes.bool,
  isCurrently: PropTypes.bool,
  isDisabled: PropTypes.bool,
}
MonthYearPicker.defaultProps = {
  field: 'field',
  value: today,
  showCurrently: false,
  isCurrently: false,
  isDisabled: false,
}

export default MonthYearPicker
